var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("v-alert", { attrs: { value: _vm.value, type: "warning" } }, [
    _vm._v("\n  Column is not implemented at the moment\n"),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }